/* 
mixins run BEFORE the local component coade 
but if there is a conflict in data names or object properties (such as methods), 
the component data takes priority

https://www.vuemastery.com/courses/next-level-vue/mixins/
*/


export const exampleMixin = {
    created() {
        console.log("Hello from the mixin - created!")
        this.logMessage()
    },
    data() {
        return {
            message: "I am such a nice mixin.'"
        }
    },
    methods: {
        logMessage() {
            console.log(this.message)
        },

        chelseaDateToYYYY_MM_DD(cDate) {
            const month3char = ["","Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]
            const month = month3char.indexOf(cDate.substring(0,3))
            let monthStr = String(month)
            if (month<=9) monthStr = "0"+monthStr
            const i = cDate.indexOf(" ")
            const j = cDate.indexOf(",")
            let dayStr = cDate.substring(i+1,j)
            if (dayStr.length==1) dayStr = "0"+dayStr
            let yearStr = cDate.substring(j+2,j+6)

            return yearStr+"-"+monthStr+"-"+dayStr
        },



    }
}